import Debug from 'debug'
import { observer } from 'mobx-react-lite'
import { Trans } from '@lingui/react/macro'

import { DisplayFilePath } from '../DisplayFilePath/DisplayFilePath'
import { isBackupOriginApiPath } from '../FileRoute/utils/apiPathToRouteContext'
import { FileApiPathLink } from '../FileRouteLink/FileApiPathLink'

import type { PathItemStore } from './PathItemStore'
import { PathItemThumb } from './PathItemThumb'

import styles from './PathItemRow.module.scss'

const debug = Debug('jotta:files:PathItemRowData')

export interface PathItemRowDataProps {
  item: PathItemStore
}

export const PathItemRowData = observer<PathItemRowDataProps>(
  function PathItemRowData({ item }: PathItemRowDataProps) {
    const { dateLabel, displayPath, fileSizeLabel, fileTypeLabel, name, path } =
      item.listItemData
    const restoreUnavailable =
      item.folder.route.isTrash && isBackupOriginApiPath(path)

    if (!item.isThumb && item.showRenameInput) {
      return null
    }

    return (
      <FileApiPathLink path={path} className={styles.rowData}>
        <PathItemThumb item={item} />
        <span className={styles.link}>
          <span className={styles.linkText}>{name}</span>
          {displayPath && (
            <span className={styles.linkPath}>
              <DisplayFilePath path={path} />
              {restoreUnavailable && (
                <>
                  {' '}
                  <Trans>(Restore unavailable)</Trans>
                </>
              )}
            </span>
          )}
        </span>

        <span className={styles.date}>{dateLabel}</span>
        <span className={styles.size}>{fileSizeLabel}</span>
        <span className={styles.type}>{fileTypeLabel}</span>
      </FileApiPathLink>
    )
  },
)
